module.exports = __webpack_public_path__ + "6644ae685d908280d359db950d629823.png";